const initialState = {
  products: [],
  cart: [],
};

export default initialState;
